<template>
    <div class="of-content-10" v-if="Object.keys(ofContent10).length > 1">
        <slider-funnels :view="ofContent10"/>
    </div>
</template>

<script>
    import SliderFunnels from "./SliderFunnels.vue";
    export default {
        name: 'of-content-10',
        props: ["view"],
        components: {
            'slider-funnels': SliderFunnels
        },
        data() {
            return {
                title: 'New Funnels of The Month',
                slides: [
                    {
                        link: '#',
                        baIntelligenceTag: 'fc-c10-new-funnel-of-month-us-x-y',
                        thumb: {
                            img: '/internacional/public/office4/img/onboarding-funnel/content-3/example_thumb.png',
                            text: 'Show Funnel'
                        },
                        title: 'Chat Bot Funnel',
                        subtitle: "PFF004 EN - Weight Loss Detox",
                        button: {
                            label: 'Download',
                            link: '#',
                            baIntelligenceTag: 'fc-c10-download-new-funnel-of-month-us-x-y'
                        }
                    },
                    {
                        link: '#',
                        baIntelligenceTag: 'fc-c10-new-funnel-of-month-us-x-y',
                        thumb: {
                            img: '/internacional/public/office4/img/onboarding-funnel/content-3/example_thumb.png',
                            text: 'Show Funnel'
                        },
                        title: 'Chat Bot Funnel',
                        subtitle: "PFF004 EN - Weight Loss Detox",
                        button: null
                    },
                    {
                        link: '#',
                        baIntelligenceTag: 'fc-c10-new-funnel-of-month-us-x-y',
                        thumb: {
                            img: '/internacional/public/office4/img/onboarding-funnel/content-3/example_thumb.png',
                            text: 'Show Funnel'
                        },
                        title: 'Chat Bot Funnel',
                        subtitle: "PFF004 EN - Weight Loss Detox",
                        button: null
                    },
                    {
                        link: '#',
                        baIntelligenceTag: 'fc-c10-new-funnel-of-month-us-x-y',
                        thumb: {
                            img: '/internacional/public/office4/img/onboarding-funnel/content-3/example_thumb.png',
                            text: 'Show Funnel'
                        },
                        title: 'Chat Bot Funnel',
                        subtitle: "PFF004 EN - Weight Loss Detox",
                        button: null
                    },
                    {
                        link: '#',
                        baIntelligenceTag: 'fc-c10-new-funnel-of-month-us-x-y',
                        thumb: {
                            img: '/internacional/public/office4/img/onboarding-funnel/content-3/example_thumb.png',
                            text: 'Show Funnel'
                        },
                        title: 'Chat Bot Funnel',
                        subtitle: "PFF004 EN - Weight Loss Detox",
                        button: null
                    },
                    {
                        link: '#',
                        baIntelligenceTag: 'fc-c10-new-funnel-of-month-us-x-y',
                        thumb: {
                            img: '/internacional/public/office4/img/onboarding-funnel/content-3/example_thumb.png',
                            text: 'Show Funnel'
                        },
                        title: 'Chat Bot Funnel',
                        subtitle: "PFF004 EN - Weight Loss Detox",
                        button: null
                    },
                    {
                        link: '#',
                        baIntelligenceTag: 'fc-c10-new-funnel-of-month-us-x-y',
                        thumb: {
                            img: '/internacional/public/office4/img/onboarding-funnel/content-3/example_thumb.png',
                            text: 'Show Funnel'
                        },
                        title: 'Chat Bot Funnel',
                        subtitle: "PFF004 EN - Weight Loss Detox",
                        button: null
                    },
                    {
                        link: '#',
                        baIntelligenceTag: 'fc-c10-new-funnel-of-month-us-x-y',
                        thumb: {
                            img: '/internacional/public/office4/img/onboarding-funnel/content-3/example_thumb.png',
                            text: 'Show Funnel'
                        },
                        title: 'Chat Bot Funnel',
                        subtitle: "PFF004 EN - Weight Loss Detox",
                        button: null
                    },
                    {
                        link: '#',
                        baIntelligenceTag: 'fc-c10-new-funnel-of-month-us-x-y',
                        thumb: {
                            img: '/internacional/public/office4/img/onboarding-funnel/content-3/example_thumb.png',
                            text: 'Show Funnel'
                        },
                        title: 'Chat Bot Funnel',
                        subtitle: "PFF004 EN - Weight Loss Detox",
                        button: null
                    },
                    {
                        link: '#',
                        baIntelligenceTag: 'fc-c10-new-funnel-of-month-us-x-y',
                        thumb: {
                            img: '/internacional/public/office4/img/onboarding-funnel/content-3/example_thumb.png',
                            text: 'Show Funnel'
                        },
                        title: 'Chat Bot Funnel',
                        subtitle: "PFF004 EN - Weight Loss Detox",
                        button: null
                    },
                    {
                        link: '#',
                        baIntelligenceTag: 'fc-c10-new-funnel-of-month-us-x-y',
                        thumb: {
                            img: '/internacional/public/office4/img/onboarding-funnel/content-3/example_thumb.png',
                            text: 'Show Funnel'
                        },
                        title: 'Chat Bot Funnel',
                        subtitle: "PFF004 EN - Weight Loss Detox",
                        button: null
                    },
                    {
                        link: '#',
                        baIntelligenceTag: 'fc-c10-new-funnel-of-month-us-x-y',
                        thumb: {
                            img: '/internacional/public/office4/img/onboarding-funnel/content-3/example_thumb.png',
                            text: 'Show Funnel'
                        },
                        title: 'Chat Bot Funnel',
                        subtitle: "PFF004 EN - Weight Loss Detox",
                        button: null
                    }
                ]
            }
        },
        computed: {
            ofContent10: function () {
                return (this.view !== undefined && this.view !== null) ? this.view : this.$data
            },
        },
        created() {},
        mounted() {}
    }
</script>

<style scoped lang="scss">
    @import "../../../../../scss/office";


    .of-content-10 {
        font: inherit;

        background-color: $of-color3;
        border-radius: 0.4em;
        padding: 3.6em 0;
        margin-bottom: 2.4em!important; /* 24px */
    }
</style>


// WEBPACK FOOTER //
// resources/office/js/components/dashboard/onboardingFunnel/content-10/index.vue